import { RADIX_COLOR_MAP, type RadixColor } from "@fitness-app/data-models/entities/CheckoutVariant";

export const colorThemeOptions = () =>
  Object.keys(RADIX_COLOR_MAP).map((color) => ({
    value: color as RadixColor,
    color: RADIX_COLOR_MAP[color as RadixColor],
  }));
